import styled from "styled-components";

export const Wrapper = styled.div`
  text-align: center;

  h1 {
    font: small-caps bold 30px/1 sans-serif;
    margin: 0 auto var(--gap) auto;
    text-align: center;
  }
`;
